module.exports = __webpack_public_path__ + "1731cc572076b6608eb27b08462acaf2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-0.png
// module id = 2033
// module chunks = 0